// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"176":"90497ec4","731":"18a483c5"}[chunkId] + ".css";
};